const LivesLimit = 20
const PostsLimit = 20

export { LivesLimit, PostsLimit }
